import * as actionTypes from './sendableStatesActionTypes';

export const setSendableStates = (sendableStates) => ({type: actionTypes.SET_SENDABLE_STATES, sendableStates:sendableStates});